import React, { Component } from 'react';

import ChecklistItem from 'components/checklist/ChecklistItem';
import PropTypes from 'prop-types';

export default class RenderChecklistPages extends Component {
  static propTypes = {
    index: PropTypes.string,
    getIcon: PropTypes.func,
    checklistId: PropTypes.string,
    pages: PropTypes.array
  };

  renderChecklistPage = (page, indexPage) => {
    const { index, getIcon, checklistId } = this.props;

    const positionIcon = 'left';
    const key = `checklist__${checklistId}__item__${index}__page__${indexPage}`;

    return (
      <ChecklistItem
        {...this.props}
        id={key}
        key={key}
        item={page}
        positionIcon={positionIcon}
        icon={getIcon(page.type)}
        className=""
      />
    );
  };

  render() {
    const { pages } = this.props;

    return pages.map(this.renderChecklistPage);
  }
}
